import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  name: "picture-verify-chip",
  computed: {
    ...mapGetters({
      userVerify: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO
    }),

    state() {
      return this.userVerify?.verification_image?.status.value;
    },

    isApprove() {
      return this.state === "VERIFIED";
    },

    isPending() {
      return this.state === "PROCESSING";
    },

    isReject() {
      return !this.state || this.state === "REJECTED";
    },

    hasIdentity() {
      return this.userVerify?.personal_information_status !== null;
    }
  },

  methods: {
    ...mapActions({
      setImageModal: types.image.actions.SET_MODAL
    }),

    openModal() {
      this.hasIdentity && this.isReject && this.setImageModal(true);
    }
  }
};
